export default __webpack_public_path__ + "static/media/banner4.94fbdf68.png";